/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureExecMaterialsModel } from './restructuring';
import { ArraysCollections } from '../../../../utils/normalize';

class TasksExecsMaterials {
  async getNotSendMaterialsByExec(state, execId) {
    const response = await api.get(
      `/tasks-execs-materials/my-not-send/${execId}`,
      {}
    );
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        items: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureExecMaterialsModel(state, item)
          ),
          'id'
        ),
        mapItems: _.chain(responseJson.data.items)
          .groupBy('task_exec_id')
          .mapValues(item => _.map(item, children => children.id))
          .value()
      }
    };
  }

  async setNotSendMaterialsByExec(state, execId, files) {
    const formData = new FormData();
    const fileNames = Object.keys(files);
    fileNames.forEach(key => formData.append('files', files[key]));
    let fileKeys;
    let uploadFailureStatus = 503;
    try {
      const uploadResponse = await api.uploadFiles(formData);
      if (!uploadResponse.ok) {
        uploadFailureStatus = uploadResponse.status;
      }
      const uploadJson = await uploadResponse.json().catch(() => ({}));
      if (!uploadResponse.ok) {
        throw new Error(
          (uploadJson && uploadJson.error) || `HTTP ${uploadResponse.status}`
        );
      }
      fileKeys = uploadJson && uploadJson.keys;
      const uuidV4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      if (
        !Array.isArray(fileKeys) ||
        fileKeys.length === 0 ||
        fileKeys.length !== fileNames.length ||
        !fileKeys.every(key => typeof key === 'string' && uuidV4.test(key))
      ) {
        throw new Error('Файловый сервис вернул некорректные ключи файлов');
      }
    } catch (error) {
      return {
        response: {
          success: false,
          status: uploadFailureStatus,
          data: { message: `Не удалось загрузить файлы: ${error.message}` }
        },
        destructData: null
      };
    }
    const response = await api.post(
      `/tasks-execs-materials/${execId}`,
      {},
      { fileKeys }
    );
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    const materialsNormalize = new ArraysCollections();
    materialsNormalize.normalize(
      responseJson.data,
      null,
      restructureExecMaterialsModel,
      state,
      'task_exec_id'
    );
    return {
      response: responseJson,
      destructData: {
        noSendExecMaterials: materialsNormalize.getItems(),
        noSendExecMaterialsMapByExec: materialsNormalize.getMap()
      }
    };
  }
  async deleteExecMaterialById(state, materialId) {
    const response = await api.del(`/tasks-execs-materials/${materialId}`, {});
    if (response.status === 204) {
      return response;
    }
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new TasksExecsMaterials();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksExecsMaterials/TasksExecsMaterials.js